import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=5439c4c3&scoped=true&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DynamicForm.vue?vue&type=style&index=1&id=5439c4c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439c4c3",
  null
  
)

export default component.exports